
export default[
    
    {
        show(row,extra){
            return row.shbj==='1'||row.shbj==='9'
        },
        tag:'my-btn',
        type:'detail',
        text:'详情',
        click(row,extra){
            this.$emit('detail')
            
        }
    },{
        show(row,extra){
            return row.shbj==='1'||row.shbj==='9'
        },
        tag:'el-button',
        icon: 'el-icon-s-promotion',
        type:'text',
        text:'进入流程',
        click(row,extra){
            this.goto({
                path: '/bidding/liucheng/index',
                query: {
                    id: row.by1
                }
            });
        }
    },
    // {
    //     show(row,extra){
    //         return row.shbj==='1'||row.shbj==='9'
    //     },
    //     tag:'el-button',
    //     icon: 'el-icon-s-promotion',
    //     type:'text',
    //     text:'进入流程(旧)',
    //     click(row,extra){
    //         this.gotoFrame({
    //             title:'招标项目流程',
    //             url:'/Zbdl/GovPurchase/newwfdis.do',
    //             q:'Q',
    //             id: row.by1,
    //         })
    //     }
    // },
    {
        show(row,extra){
            return row.shbj!=='1'&&row.shbj!=='9'
        },
        tag:'my-btn',
        type:'del',
        text:'删除',
        click(row,extra){
            this.$post(`${this.getGetters('mngUrl')}/revision/Zbdl/GovPurchase/del.json`,{
                id:row.zbprocode,
                oper:'del'
            }, (data, res) => {
                ShowMsg('删除成功','success')
                this.$emit('reload')
            });
        }
    },{
        show(row,extra){
            return row.shbj!=='1'&&row.shbj!=='9'
        },
        tag:'my-btn',
        type:'edit',
        text:'修改',
        click(row,extra){
            this.goto({
                path: '/bidding/project/zfcg/form',
                query: {
                    type: this.getQuery('type'),
                    ext3childtype: this.getQuery('ext3childtype'),
                    zbprocode:row.zbprocode
                }
            });
        }
    },
    
]